import React, { useState } from 'react';
import '@shopify/polaris/styles.css';

import {
  ChevronDownMinor
} from '@shopify/polaris-icons';

import { Icon, Popover, ActionList, Avatar } from '@shopify/polaris';
import PakkepostSettingsModal from './PakkepostSettingsModal';

import { 
  shopDetails,
} from '../interfaces';

interface Props {
  shopDetails: shopDetails,
  setShopDetails: Function,
  setShowInfoPage: (flag: boolean) => void,
}

const Header = ({
  shopDetails,
  setShopDetails,
  setShowInfoPage,
}: Props) => {
  const [isActionsListOpen, setIsActionsListOpen] = useState(false);
  // Modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleToggleActionList = () => {
    setIsActionsListOpen(!isActionsListOpen)
  }

  const handleToggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setIsActionsListOpen(false);
  }

  const actionsListActivator = (
    <div 
      onClick={() => {
        handleToggleActionList();
      }}
      className="profile"
    >
      <Avatar customer name={`${shopDetails.name}`} size="small"/>
      <div className="profile-info">
        <span className="user-name"> 
          {shopDetails.name}
        </span>
        <span className="user-role">
          Administrator
        </span>
      </div>
      <div className="btn-container">
        <button className="btn-open-action-list" >
          <Icon source={ChevronDownMinor} />
        </button>
      </div>
    </div>
  );

  return (
    <header className="header">
      <div>
        <img alt="pakkepost-icon" src='/assets/pakkepost-icon.png' height={55} width={250} />
        </div>
      <div className="profile-wrapper">
        <div>
          <Popover 
            active={isActionsListOpen} 
            activator={actionsListActivator}
            onClose={() => {
              handleToggleActionList();
            }}
          >
            <ActionList
              items={[
                {
                  content: 'Pakkepost settings',
                  onAction: () => {
                    handleToggleModal();
                  },
                },
                {
                  content: 'Instructions',
                  onAction: () => {
                    setShowInfoPage(true);
                    handleToggleActionList();
                  },
                },
              ]}
            />
          </Popover>
        </div>
      </div>
      <PakkepostSettingsModal 
        isModalOpen={isModalOpen} 
        handleToggleModal={handleToggleModal}
        setShopDetails={setShopDetails}
        shopDetails={shopDetails}
      />
    </header>
  );
}

export default Header;
